import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import { downloadBlob } from "@/lib/download-blob";

/**
 * Triggers an "Export to Equip dashboard" download for a collection's
 * city-approved stations. Downloads immediately and toasts the station count
 * (or a notice when there's nothing to export).
 */
export function useEquipStationExport(collectionId: string | undefined) {
  const mutation = trpc.export.equipStations.useMutation();

  async function exportToEquip() {
    if (!collectionId) return;
    try {
      const result = await mutation.mutateAsync({ collectionId });
      if (result.count === 0) {
        toast.info("No city-approved stations to export");
        return;
      }
      downloadBlob(result.data, result.filename, result.mimeType);
      toast.success(
        `Exported ${result.count} station${result.count === 1 ? "" : "s"} to Equip dashboard`,
      );
    } catch (err) {
      toast.error(
        err instanceof Error ? err.message : "Failed to export stations",
      );
    }
  }

  return { exportToEquip, isExporting: mutation.isPending };
}
